import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import infoIco from 'assets/images/i-circle.svg';
import { Button } from 'react-bootstrap';
// import logo from 'assets/images/eb-logo.svg';
import logo from 'assets/images/axlerate-logo.png';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import api from 'api/client';
import OtpModal from 'shared/common/modal/otp_modal';
import { toast } from 'react-toastify';
import LoginService from './services/resetPassword.service';
import Toast from '../../shared/common/toast';
import backIco from 'assets/images/back.png';
import hidden from '../../assets/images/hidden.png';
import eye from '../../assets/images/eye.png';
import format from 'string-template';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  FORGOT_RESET_MESSAGE,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
} from 'constants/messages.constant';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import { userStore } from 'store/UserStore';

interface PropsType {}

const ResetPassword: () => void = () => {
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [formShow, setformShow] = useState(false);
  const [mobile, setMobile] = useState('');
  const [destination, setDestination] = useState('');
  const [password, setPassword] = useState('');
  const [values, setVal] = useState({});
  const [txtSuscces, setTxtSuscces] = useState('');
  const [txtError, setTxtError] = useState('');
  const history = useHistory();
  const [modalShow, setModalShow] = React.useState(false);
  const [countryCode, setCountryCode] = useState('+91');
  const [isShowPwd, setShowPwd] = React.useState(false);
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const [user] = userStore((state: any) => [state.user]);

  useEffect(() => {
    if (otpData.value?.length === 6) confirm();
  }, [otpData.value]);

  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const sendOtp = async () => {
    // setPassword(val.password);
    try {
      const res: any = await LoginService.sendOTP(mobile);
      if (res) {
        setTxtError('');
        setTxtSuscces('OTP has been sent to the registered mobile');
        setModalShow(true);
        setIsOtpVerified(false);
      }
    } catch (err: any) {
      toast.error(err.message);
      setTxtSuscces('');
      setTxtError('There was an error in sending the OTP');
    }
  };

  const onSuccess = async (otp: any, val: any) => {
    setPassword(val.password);
    setMobile(`+91${val.mobile}`);
    try {
      const res: any = await LoginService.resetPassword(
        `+91${val.mobile}`,
        otp,
        val.password
      );
      if (res) {
        setTxtError('');
        setTxtSuscces('OTP has been sent to the registered mobile');
        setModalShow(true);
        setDestination(res.CodeDeliveryDetails.Destination);
        setIsOtpVerified(false);
      }
    } catch (err: any) {
      setDestination('');
      console.log(err);
      toast.error(err.message);
    }
  };

  const confirm = async () => {
    try {
      setLoading(true);
      const res: any = await LoginService.confirmPassword(
        mobile,
        otpData?.value,
        password
      );
      setLoading(true);
      if (res) {
        setOtpData({
          ...otpData,
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success(
          'Password has been reset successfully. You will be redirected to Sign-in screen now..',
          {
            hideProgressBar: false,
            autoClose: 3000,
          }
        );

        setDestination('');
        setIsOtpVerified(true);
        setModalShow(false);
        setTimeout(() => {
          history.push('/signin');
        }, 3000);
      }
    } catch (err: any) {
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      console.log(err);
      toast.error(err.message);
    }
  };

  const handelBack = () => {
    if (!formShow) {
      history.push('/signin');
    } else {
      setformShow(false);
    }
  };

  return (
    <div>
      <Toast />
      <div className='login-wrapper'>
        <div className='login-banner d-none d-sm-block d-sm-flex'>
          {/* <img src={logo} alt='' /> */}
        </div>
        <div className='login-form'>
          <div className='login-form-group'>
            <div className='mb-5'>
              <a href='#' onClick={handelBack}>
                <img style={{ width: '20px' }} src={backIco} alt='' />
              </a>
            </div>
            <div className='title'>
              <h3>Reset Your Password</h3>
            </div>
            {
              <Formik
                initialValues={{ mobile: '', password: '' }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(false);
                  onSuccess('0', values);
                  // resetForm({
                  //   values: {
                  //     password: '',
                  //   },
                  // });
                }}
                validationSchema={Yup.object().shape({
                  mobile: Yup.string()
                    .min(10, 'Invalid mobile number')
                    .max(10, 'Invalid mobile number')
                    .required('Invalid mobile number'),
                  password: Yup.string()
                    .required('Password is required')
                    .matches(
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                      'The password must be at least 8 characters and it must contain at least one uppercase, one lowercase, one number and one special character.'
                    ),
                })}
              >
                {({ isSubmitting, errors, touched, setFieldValue }) => (
                  <Form translate={undefined}>
                    <div className='form-group mb-2'>
                      <label className='form-label'>Mobile</label>
                      <div className='input-group mb-3'>
                        <div className='input-group-text' id='basic-addon1'>
                          <select
                            className='form-control country-select'
                            onChange={(event) =>
                              setCountryCode(event.target.value)
                            }
                            value={countryCode}
                          >
                            <option value={'+91'}>+91</option>
                          </select>
                        </div>
                        <Field
                          type='text'
                          placeholder='Mobile'
                          name='mobile'
                          className='form-control'
                          onChange={(e) => {
                            if (
                              e.target.value.length > 10 ||
                              /[^0-9]/.test(e.target.value)
                            )
                              return;
                            setFieldValue('mobile', e.target.value);
                          }}
                        />
                      </div>
                      <div className='error'>
                        {errors.mobile && touched.mobile && (
                          <small id='my-helper-text'>
                            <img src={infoIco} alt='' />
                            {errors.mobile}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className='form-group mb-2'>
                      <label className='form-label'>New Password</label>
                      <div className='input-group mb-3'>
                        <Field
                          type={isShowPwd ? 'text' : 'password'}
                          placeholder='Password'
                          name='password'
                          style={{ position: 'unset' }}
                          className='form-control'
                        />
                        <div
                          className='input-group-text'
                          id='basic-addon1'
                          style={{
                            border: '1px solid #ced4da',
                            borderLeft: '0px',
                            backgroundColor: 'white',
                            borderRadius: '0rem 0.25rem 0.25rem 0rem',
                          }}
                        >
                          <a href='#' onClick={() => setShowPwd(!isShowPwd)}>
                            <img
                              className='m-2'
                              style={{ width: '16px' }}
                              src={isShowPwd ? hidden : eye}
                              alt=''
                            />
                          </a>
                        </div>
                      </div>
                      {/* <div className='error'>
                        {formShow && errors.password && touched.password && (
                          <small id='my-helper-text'>
                            <img src={infoIco} alt='' />
                            {errors.password}
                          </small>
                        )}
                      </div> */}
                      <div className='form-group'>
                        <div className='error-password'>
                          {errors.password && touched.password && (
                            <small id='my-helper-text'>
                              <img src={infoIco} alt='' />
                              {errors.password}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <Button
                      className='w-100 mt-3'
                      variant='primary'
                      type='submit'
                    >
                      Receive OTP
                    </Button>
                  </Form>
                )}
              </Formik>
            }
          </div>
        </div>
      </div>
      <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title='Enter the OTP sent to  your registered mobile number'
        onSuccess={(otp) => confirm()}
        resend={sendOtp}
        txtSuscces={txtSuscces}
        txtError={txtError}
        isVerified={isOtpVerified}
        loading={loading}
      />
      <OtpPopup
        show={modalShow}
        isLoading={loading}
        handleClose={() => {
          resetOtpData();
          setModalShow(false);
        }}
        modalTitle={`User Password Reset Confirmation`}
        modalSubmitBtnText='Verify'
        onSubmit={() => confirm()}
        otpLabel={format(FORGOT_RESET_MESSAGE, {
          mobile: destination,
        })}
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          sendOtp();
        }}
        otpChangeHandler={(value) => {
          setOtpData({
            value: value,
            ackMessage: '',
            ackMessageType: 'success',
          });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />
    </div>
  );
};

export default ResetPassword;
